module.exports = "/assets/data/67a713fec1d89b9debc229747997710b-EH33.data.json";